// Module
var code = "<div class=\"progress-line__indicator\" data-bind=\"style: {\n  width: ko.toJS(progress) + '%'\n}, attr: { 'data-progress': progress }\"></div>\n";
// Exports
module.exports = code;